import { BaseService } from "./base.service";
import { API_ENDPOINTS } from "../utils/endpoints";
import { CreateUserRequest } from "../queries/models/create-user-request.model";
import { UpdateUserRequest } from "../queries/models/update-user-request";
import { SelectItem } from "primereact/selectitem";
import { SkillLevel } from "../queries/models/skill-level.model";

class SkillLevelsService extends BaseService {

    async getAllActive(): Promise<SkillLevel[]> {
        const url = `${this.endpointPath}/active`;
        return this.http.get<SkillLevel[]>(url).then((response: any) => response.data);
    }

    async getAllActiveAsOptions(): Promise<SelectItem[]> {
        const url = `${this.endpointPath}/active-as-options`;
        return this.http.get<SelectItem[]>(url).then((response: any) => response.data);
    }

    async getLevelByRiderHorse(riderId: number, horseId: number): Promise<number | undefined> {
        const url = `${this.endpointPath}/by-rider-horse/${riderId}/${horseId}`;
        return this.http.get<number | undefined>(url).then((response: any) => response.data);
    }

    async add(request: SkillLevel) {
        const url = `${this.endpointPath}/create`;
        return this.http.post<CreateUserRequest>(url, request).then((response: any) => response.data);
    }
    async edit(request: SkillLevel) {
        const url = `${this.endpointPath}/update`;
        return this.http.put<UpdateUserRequest>(url, request).then((response: any) => response.data);
    }

    async delete(id: number) {
        const url = `${this.endpointPath}/delete/${id}`;
        return this.http.delete(url).then((response: any) => response.data);
    }
}

export const skillLevelsService = new SkillLevelsService(API_ENDPOINTS.SKILL_LEVELS);